import React from 'react';
import SingleButton from './SingleButton';
import { green } from '@mui/material/colors';
import CloseIcon from '@mui/icons-material/Close';

function CancelButton({ onClickCancel, disabled }) {
  return (
    <SingleButton
      variant="outlined"
      borderColor={green[800]}
      textColor={green[800]}
      hoverColor={green[100]}
      startIcon={<CloseIcon />}
      onClick={onClickCancel}
      disabled={disabled}
    >
      Cancelar
    </SingleButton>
  );
}

export default CancelButton;
